import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { DialogRoute, TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { PodcastItemComponent } from './podcast-item/podcast-item.component';
import { PodcastComponent } from './podcast/podcast.component';
import { PodcastsComponent } from './podcasts/podcasts.component';
import { ShowsModule } from '@tytapp/shows';
import { SlugComponent } from '@tytapp/slugs';

export { PodcastComponent }

@NgModule({
    declarations: [
        PodcastComponent,
        PodcastsComponent,
        PodcastItemComponent
    ],
    imports: [
        CommonModule,
        TYTCommonModule,
        CommonUiModule,
        ShowsModule,
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatInputModule,
        RouterModule.forChild([
            /**
             * The Podcasts home page is available for customization via the
             * Page Builder system. We use an explicit SlugComponent outlet here
             * to enable that, which is required because Angular will route all
             * /podcasts/* routes to this child router, sol it will not hit the
             * global SlugComponent route.
             */
            SlugComponent.outlet('', { fallbackUrl: '/podcasts/v1', masked: true }),
            {
                path: 'v1',
                component: PodcastsComponent
            },
            DialogRoute(':id', PodcastComponent, [':id'])
        ])
    ]
})
export class PodcastPagesModule {

}